import { Menu } from 'lucide-react';

import BetaIcon from '@/assets/icons/beta-icon.svg?react';
import LogoText from '@/assets/icons/logo-text.svg?react';
import ModeSwitcher from '@/assets/icons/mode-switcher.svg?react';
import Logo from '@/assets/icons/rhb-logo.svg?react';
import RoleSwitcher from '@/components/layout/top-nav/role-switcher';
import { Button } from '@/components/ui/button';
import { SheetTrigger } from '@/components/ui/sheet';
import useAuth from '@/hooks/use-auth';
import useRoleAccess from '@/hooks/use-role-access';
import { useThemeContext } from '@/hooks/use-theme-context';

type TopNavProps = {
  onSwitchRole?: (role: string, onSettled?: () => void) => void;
  isRoleSwitching?: boolean;
  isTabSwitching?: boolean;
  visibility?: boolean;
};

export default function TopNav({
  onSwitchRole,
  isRoleSwitching = false,
  isTabSwitching = false,
  visibility = true,
}: TopNavProps) {
  const { toggleTheme } = useThemeContext();
  const { activeRole } = useAuth();
  const { showRoleSwitcher } = useRoleAccess();

  const shouldShowRoleSwitcher = showRoleSwitcher && !!onSwitchRole && !isTabSwitching;

  return (
    <header className="bg-primary sticky top-0 z-50 h-17 rounded-br-4xl px-8 py-4">
      <div className="flex h-10 items-center justify-between">
        <div className="flex items-center gap-3">
          <Logo className="h-5" />
          <LogoText className="h-5" />
          <BetaIcon className="h-10" />
        </div>

        <div className="flex items-center gap-4">
          {visibility && (
            <>
              {shouldShowRoleSwitcher && (
                <>
                  <RoleSwitcher
                    activeRole={activeRole}
                    isRoleSwitching={isRoleSwitching}
                    onSwitchRole={onSwitchRole!}
                  />
                  <div className="bg-role-switcher-divider h-5" />
                </>
              )}
            </>
          )}

          <Button variant="ghost" size="icon" onClick={toggleTheme}>
            <ModeSwitcher />
          </Button>

          {visibility && (
            <SheetTrigger asChild>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                aria-controls="sidepanel-sheet"
                aria-label="Open menu"
              >
                <Menu className="text-white" />
              </Button>
            </SheetTrigger>
          )}
        </div>
      </div>
    </header>
  );
}
